import styled from 'styled-components';

import { COLORS } from 'constants/colors';

export const StyledBullet = styled.span`
  margin: 0 6px;
  font-color: ${COLORS.ActiveUserText};
`;
